import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "my_modal_2",
  class: "rounded"
}
const _hoisted_2 = { class: "flex flex-col justify-center p-4" }
const _hoisted_3 = { class: "flex flex-row justify-center space-x-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-2xl text-center" }, "All changes to user:", -1)
const _hoisted_5 = { class: "mt-4" }

import { IspsTruckerChangeTO } from "@/services/api-client/client";
import HistoryTable from "./HistoryTable.vue";
import { watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryDialog',
  props: {
    users: {},
    openDialog: { type: Boolean }
  },
  emits: ["approve"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

watch(
  () => props.openDialog,
  async (_) => {
    const dialog = document.getElementById("my_modal_2");
    (dialog as HTMLDialogElement)?.showModal();
  }
);

const sendApproval = (payload: { approve: boolean; id: number }) => {
  closeDialog();
  emit("approve", payload);
};

const closeDialog = () => {
  const dialog = document.getElementById("my_modal_2");
  (dialog as HTMLDialogElement)?.close();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => closeDialog()),
          class: "btn btn-info btn-sm mr-2"
        }, " Close dialog ")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(HistoryTable, {
          onApprove: _cache[1] || (_cache[1] = (t) => sendApproval(t)),
          users: props.users
        }, null, 8, ["users"])
      ])
    ])
  ]))
}
}

})